export const Files = {
  CANDIDATE_INTERVIEW: 'interview-media',
  EMAIL_ATTACHMENTS: 'email-attachments',
  STAFF_PROFILE_PICTURE: 'staff-profile-picture',
  STAFF_IDENTITY_DOCUMENT: 'staff-identity-document',
  STAFF_DIPLOMA: 'staff-diploma',
  STAFF_CRIMINAL_RECORD: 'staff-criminal-record',
  STAFF_PAYSLIP: 'staff-payslip',
  ETA: 'eta',
  OPTION_PICTO: 'option-picto',
  OPTION_PICTURE: 'option-picture',
  ACCOMODATION_TYPE_PICTO: 'accomodation-type-picto',
  CENTER_EVENT: 'center-event',
  CENTER_EVENT_ACTION: 'center-event-action',
  OL_PICTURE: 'ol',
  TEFL_DOCUMENT: 'tefl-document',
  TEFL_DIPLOMA: 'tefl-diploma',
  TEACHING_HALL: 'teaching-hall',
  TRIP_BOOKING_DOCUMENT: 'trip-booking-document',
  TRANSPORT_MEAN_PICTO: 'transport-mean-picto',
  QUOTATION_FILE: 'quotation-file',
  TEMPORARY_FILES: 'temp',
  HOST_FAMILY_PICTURES_AND_VIDEOS: 'host-family-pictures-and-videos',
  TRIP_FOLDER_DOCUMENT: 'trip-folder-document',
  CENTER_TEFL_COSTS_INVOICE: 'center-tefl-costs-invoice',
  CENTER_TEACHING_HALL_COSTS_INVOICE: 'center-teaching-hall-costs-invoice',
  CENTER_CULTURAL_OUTING_INVOICE: 'center-cultural-outing-invoice',
  CENTER_ARRIVAL_DEPARTURE_TRANSFER_INVOICE: 'center-arrival-departure-transfer-invoice',
  CENTER_BUDGET_INVOICE: 'center-budget-invoice',
  CENTER_ACTIVITY_INVOICE: 'center-activity-invoice',
  CENTER_EXCEPTIONAL_EXPENSES_INVOICE: 'center-exceptional-expenses-invoice',
  GUIDE_PICTO: 'guide-picto',
  GUIDE_PDF: 'guide-pdf',
  ENROLLMENT_PROFILE_PICTURE: 'enrollment-profile-picture',
  CENTER_OL_PAYMENT_INVOICES: 'center-ol-payment-invoices',
  ENROLLMENT_PROFILE_ID_CARD: 'enrollment-id-card',
  ENROLLMENT_FAMILY_IMAGES: 'enrollment-family-images',
  AFFECTED_STAFF_QUESTIONNAIRE_FAMILY_IMAGES: 'affected-staff-questionnaire-family-images',
  HOBBY_PICTO: 'hobby-picto',
  TRIP_ADDRESS_PICTURES: 'trip-address-pictures',
  TRAVEL_EXPENSES_INVOICE: 'travel-expenses-invoice',
  CENTER_PROGRAM_DOCUMENT: 'center-program-document',
  CSE_LOGO: 'cse-logos',
  CENTER_GROUP_DOCUMENT: 'center-group-document'
}

export type FilesType = (typeof Files)[keyof typeof Files]
